import { BillingBucketDTO } from "../DTO/billingBucketDTO";
import { Vendor } from "./vendor";

export class BillingBucket{
    public id!:number;
    public name!:string;
    public enabled!:boolean;
    public vendorId?:number;
    private _vendor? : Vendor;
    public added! : Date;
    public edited! : Date;

    get status(){
        return this.enabled?"Active":"Inactive";
    }

    set vendor(value:Vendor|undefined){
        this._vendor=value;
        this.vendorId=value?.id;
    }
    get vendor(){
        return this._vendor;
    }

    public static mapFromDTO(param:BillingBucketDTO):BillingBucket{ 
        if (!param) throw new Error("parameter is null")
        let obj = new BillingBucket();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.vendorId = param.vendorId;
            obj.enabled = param.enabled
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.added = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:BillingBucket):BillingBucketDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new BillingBucketDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.vendorId = param.vendor?.id;
            dto.enabled = param.enabled;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.added = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}